/**
 * @generated SignedSource<<46b73ebefadefb99bded510ccf279ba5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EntityUpdateThemeInput = {
  clientMutationId?: string | null | undefined;
  entityThemeData: EntityUpdateTheme;
};
export type EntityUpdateTheme = {
  id: string;
  theme: string;
};
export type GlobalContextProviderUpdateEntityThemeMutation$variables = {
  input: EntityUpdateThemeInput;
};
export type GlobalContextProviderUpdateEntityThemeMutation$data = {
  readonly entityUpdateTheme: {
    readonly entity: {
      readonly __typename: string;
      readonly theme: string | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<string>;
  };
};
export type GlobalContextProviderUpdateEntityThemeMutation = {
  response: GlobalContextProviderUpdateEntityThemeMutation$data;
  variables: GlobalContextProviderUpdateEntityThemeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "theme",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GlobalContextProviderUpdateEntityThemeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "EntityUpdateThemePayload",
        "kind": "LinkedField",
        "name": "entityUpdateTheme",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "GlobalContextProviderUpdateEntityThemeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "EntityUpdateThemePayload",
        "kind": "LinkedField",
        "name": "entityUpdateTheme",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fdf8031b9b91a6201a962e6a052fa94e",
    "id": null,
    "metadata": {},
    "name": "GlobalContextProviderUpdateEntityThemeMutation",
    "operationKind": "mutation",
    "text": "mutation GlobalContextProviderUpdateEntityThemeMutation(\n  $input: EntityUpdateThemeInput!\n) {\n  entityUpdateTheme(input: $input) {\n    errors\n    entity {\n      __typename\n      theme\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "838b3ee0ea227f50026bb05cd67a0e1a";

export default node;
